import dayjs from 'dayjs';
import UTC from 'dayjs/plugin/utc';
dayjs.extend(UTC);

export class DateUtilities {
  public static stripTimeAndTimeZoneInfo(date: Date | string | null): Date | null {
    if (date === null) {
      return null;
    } else {
      return dayjs(dayjs.utc(date).format('YYYY-MM-DDT00:00:00')).toDate();
    }
  }
}
